module.exports = __webpack_public_path__ + "img/trash.e57495ec.svg";